import { useCallback, useContext, useEffect, useState } from 'react';
import { getPinnedScenarios } from '../../services/PinScenarioServices';
import ScenarioCard from "../mainlayout/body/ScenarioCard";
import styles from './styles/PinScenarioView.module.css';
import AuthContext from "../../context/AuthContext";


const PinScenarioView = ({ creatorId }) => {
    const [pinnedScenarios, setPinnedScenarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { userId } = useContext(AuthContext);
    const isAuthor = userId?.toString() === creatorId?.toString();

    const fetchPinnedScenarios = useCallback(async () => {
        if (!creatorId) {
            return;
        }

        try { // Load the creator's pinned scenarios
            setLoading(true);
            setError(false);

            const data = await getPinnedScenarios(creatorId);
            // Defensive: skip pins whose scenario is missing (deleted/filtered server-side)
            setPinnedScenarios(data.filter((pin) => pin.scenario));
        } catch (err) {
            console.error('Error fetching pinned scenarios:', err);
            setError(true);
        } finally {
            setLoading(false);
        }
    }, [creatorId]);

    useEffect(() => {
        fetchPinnedScenarios();
    }, [fetchPinnedScenarios]); // Refetch whenever the viewed profile changes

    // Visitors only see the section when there's something to show;
    // the owner always sees it (with loading/error/empty feedback).
    if (!isAuthor && (loading || error || pinnedScenarios.length === 0)) {
        return null;
    }

    return (
        <section className={styles.pinnedSection}>
            <h2 className={styles.heading}>Pinned Scenarios</h2>

            {loading ? (
                <p className={styles.message}>Loading pinned scenarios...</p>
            ) : error ? (
                <p className={styles.message}>Unable to load pinned scenarios.</p>
            ) : pinnedScenarios.length === 0 ? (
                <p className={styles.message}>
                    No pinned scenarios yet. Pin up to 3 from a scenario's options menu.
                </p>
            ) : (
                <div className={styles.pinnedList}>
                    {pinnedScenarios.map((pin) => (
                        <ScenarioCard
                            key={pin._id}
                            scenario={pin.scenario}
                            isAuthor={isAuthor}
                            onPinChange={fetchPinnedScenarios}
                        />
                    ))}
                </div>
            )}
        </section>
    );
};

export default PinScenarioView;
